import get from "lodash/get";
import head from "lodash/head";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Box, Button, Stack, TextField } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useIsMobile } from "../actions/ui";
import { briefGalleryList } from "../v2_actions/brief_gallery";
import { albumListForEventTab } from "../v2_actions/customer_album";
import { formatSessionNameForURL } from "../v2_actions/nav";

const useStyles = makeStyles((theme) => ({
  submitBibNumber: {
    height: 40,
    width: 20,
    fontSize: 10,
    cursor: "pointer",
  },
  cancelButton: {
    height: 28,
    width: 134,
    background: "#929292",
    "& p": {
      fontSize: 12,
      fontWeight: 600,
    },
  },
  submitButton: {
    height: 28,
    width: 134,
    "& p": {
      fontSize: 12,
      fontWeight: 600,
    },
  },
  bibNumberInput: {
    "& input": {
      textAlign: "center",
    },
    "& input::placeholder": {
      textAlign: "center",
    },
  },
}));

export default function AlbumBibNumber({
  albumNameForAPI,
  clearFiltersWasClicked,
  setClearFiltersWasClicked,
  setExpandActiveMobileTabFilter,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [bibNumber, setBibNumber] = useState("");
  const gallery = head(useSelector(() => briefGalleryList.getVisibleObjects()));
  const albumId = useSelector(() => albumListForEventTab.getIdForAlbumName(albumNameForAPI));
  const sessionNameForUrl = gallery && formatSessionNameForURL(get(gallery, "session_name"));
  const dbId = get(gallery, "db_id");

  useEffect(() => {
    if (clearFiltersWasClicked) {
      setBibNumber("");
    }
    setClearFiltersWasClicked(false);
  }, [clearFiltersWasClicked]);

  const onChangeBibNumber = (event) => {
    setBibNumber(event.target.value);
  };

  const onSubmitBibNumber = () => {
    if (setExpandActiveMobileTabFilter) {
      setExpandActiveMobileTabFilter(false);
    }
    if (bibNumber && albumId && sessionNameForUrl && dbId) {
      const urlParams = new URLSearchParams({
        bibNumber: bibNumber,
        albumId: albumId,
      });
      navigate(`/customer/gallery/${sessionNameForUrl}/${dbId}?${urlParams}`);
    }
  };

  const onCancelBibNumber = () => {
    setBibNumber("");
    if (setExpandActiveMobileTabFilter) {
      setExpandActiveMobileTabFilter(false);
    }
  };

  return (
    <Box sx={{ width: 300 }}>
      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <TextField
          size="small"
          variant="outlined"
          value={bibNumber}
          placeholder="Enter bib number"
          onChange={onChangeBibNumber}
          autoComplete="bibnumber"
          className={classes.bibNumberInput}
          inputProps={{ style: { textAlign: "center" } }}
        />
        {!isMobile && (
          <ArrowForwardIosIcon
            onClick={onSubmitBibNumber}
            className={classes.submitBibNumber}
          />
        )}
      </Stack>
      {isMobile && (
        <Stack
          mt={3}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            variant="contained"
            sx={{ background: "#929292" }}
            className={classes.cancelButton}
            onClick={onCancelBibNumber}
          >
            <p>Cancel</p>
          </Button>
          <Button
            variant="contained"
            onClick={onSubmitBibNumber}
            className={classes.submitButton}
          >
            <p>Search</p>
          </Button>
        </Stack>
      )}
    </Box>
  );
}
